import { FC, useContext, useEffect, useState } from "react";
import { Button, CustomLink, Layout } from "../../components";
import logo from "../../assets/logo.svg";
import { Context } from "../..";
import { useNavigate } from "react-router-dom";
import $api from "../../http";
import config from "../../config";
import styled from "styled-components";
import { observer } from "mobx-react";

const Table = styled.table`
  width: 100%;
  tr {
    padding-top: 20px;
    :nth-child(odd) {
      background-color: #eee;
    }
  }
  @media(max-width: 700px) {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    tr {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
    }
  }
`;

const StatMonth: FC<{ title: string }> = observer(({ title }) => {
  const { store } = useContext(Context);
  const navigate = useNavigate();
  useEffect(() => {
    if (!store.isAuth) return navigate("/");
  }, [store, navigate]);

  const [stat, setStat] = useState<any[]>();
  const [month, setMonth] = useState<string>(new Date().toLocaleDateString("ru").split(".")[1]);
  const [months, setMonths] = useState([`01`]);

  useEffect(() => {
    $api.get(`${config.API}/master/stat?month=${month}`).then(({ data }) => {
      setStat(data.data);
      console.log(data.data);
    });
    for(let i = 2; i <= Number(month); i++) {
      setMonths(prev => [...prev, i.toString().length < 2 ? `0${i}` : `${i}`]);
    }
  }, [month]);

  const exportExcel = () => {
    $api.get(`${config.API}/master/exportlogs?date=${month}`).then(({ data }) => {
      window.open(`${config.API}/${data.data}`);
    });
  };
  return (
    <Layout title={title}>
      <img src={logo} alt="Chiorio logotype" width={128} height={128} />
      <CustomLink to="/admin">{"<-"} В админку</CustomLink>
      <Button onClick={exportExcel}>Сохранить в Excel</Button>
      <div style={{display: "flex", gap: 10}}>
        {months.map((e) => {
          return (
            <span key={e} onClick={() => setMonth(e)}>
              {e}{" "}
            </span>
          );
        })}

      </div>
      <Table>
        <tr>
          <td>Дата</td>
          <td>Время</td>
          <td>Клиент</td>
          <td>Телефон</td>
          <td>Мастер</td>
          <td>Посещение</td>
          <td>Бесплатное</td>
          <td>Чек</td>
        </tr>
        {stat &&
          stat.map((e: any) => {
            return (
              <tr key={e._id}>
                <td>{e.date}</td>
                <td>{e.time}</td>
                <td>{e.client}</td>
                <td>{e.phone}</td>
                <td>{e.master}</td>
                <td>{e.count}</td>
                <td>{e.isSix ? "Да" : "Нет"}</td>
                <td>{Number(e.productPrice) || 0 + Number(e.servicePrice) || 0}</td>
              </tr>
            );
          })}
      </Table>
    </Layout>
  );
});

export default StatMonth;
